module.exports = __webpack_public_path__ + "static/img/video-pass.bfa9fd30.png";